/**
 * Datensparsame Nutzungsstatistik mit TelemetryDeck.
 *
 * - Es wird nichts im Browser gespeichert: Nicht angemeldete Spieler bekommen pro Seitenaufruf eine zufällige
 *   Kennung, die nur im Arbeitsspeicher liegt. Angemeldete werden über ihre Konto-ID gezählt.
 * - Die Kennung wird im Browser gesalzen und gehasht, TelemetryDeck hasht sie beim Empfang erneut.
 * - Gesendet werden nur Ereignisname und die hier angegebenen Werte (keine E-Mail, keine Namen, keine Texte).
 * - Bei „Do Not Track“ und in Tests wird nichts gesendet; im Entwicklungsmodus landen Signale im Testmodus.
 */
import TelemetryDeck from '@telemetrydeck/sdk';

export const TD_APP_ID = '2474ECC7-D237-4D7A-884F-01C023E8BC50';
const SALT = 'kabinett-politiksimulation-2026';

type Payload = Record<string, string | number | boolean | null | undefined>;

const rid = () => (typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36));
const sessionID = rid();
let anonUser = rid();
let accountUser: string | null = null;
let td: TelemetryDeck | null = null;

function enabled(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  if ((import.meta as any).env?.MODE === 'test') return false;
  if (navigator.doNotTrack === '1' || (window as any).doNotTrack === '1') return false;
  return true;
}

function client(): TelemetryDeck | null {
  if (!enabled()) return null;
  if (!td) td = new TelemetryDeck({ appID: TD_APP_ID, clientUser: anonUser, sessionID, salt: SALT, testMode: !!(import.meta as any).env?.DEV });
  return td;
}

/** Konto-ID setzen (oder null beim Abmelden). Danach zählen Signale für dieses Konto. */
export function setTelemetryUser(id: string | null) {
  if (id === accountUser) return;
  accountUser = id;
  if (!id) anonUser = rid();
}

/** Signal senden. Fehler (offline, Blocker) werden still ignoriert. */
export function track(type: string, payload: Payload = {}) {
  const c = client(); if (!c) return;
  const clean: Record<string, string | number> = {};
  for (const [k, v] of Object.entries(payload)) if (v !== undefined && v !== null) clean[k] = typeof v === 'boolean' ? String(v) : v;
  c.signal(type, clean, { clientUser: accountUser ?? anonUser } as any).catch(() => { /* egal */ });
}
